export const populatePageMetaAppInput = ({
  title,
  description,
  imageUrl,
  page
}) => {
  return {
    URL: page === null || page === void 0 ? void 0 : page.baseUrl,
    description,
    imageUrl,
    title
  };
};